import React from 'react'
import { Controller } from 'react-hook-form'
import { runSsnValidation } from '../../../../utils/validators'
import { patientFormErrors } from '../../_errors'
import { usePatientFormContext } from '../../context/PatientFormContext'
import { socialSecurityNumberMinLength, useFormContextPatient } from '../_utils'
import PatientFormField from '../PatientFormField'

const PatientSocialSecurityNumber: React.FC = () => {
    const { control, watch } = useFormContextPatient()

    const { state } = usePatientFormContext()

    const patientIsSameAsInsuredWatched = watch('patientIsSameAsInsured') ?? true

    const isDisabled = state.isDisabled || !patientIsSameAsInsuredWatched

    return (
        <Controller
            control={control}
            name="socialSecurityNumber"
            rules={{
                required: patientIsSameAsInsuredWatched ? patientFormErrors.socialSecurityNumber?.required : false,
                minLength: patientIsSameAsInsuredWatched
                    ? {
                          value: socialSecurityNumberMinLength,
                          message: patientFormErrors.socialSecurityNumber?.minLength ?? '',
                      }
                    : undefined,
                maxLength: patientIsSameAsInsuredWatched ? socialSecurityNumberMinLength : undefined,
                validate: patientIsSameAsInsuredWatched
                    ? (val) => {
                          if (val) {
                              const watched = {
                                  birthDate: watch('birthDate'),
                                  sex: watch('sex'),
                              }

                              return runSsnValidation({
                                  ssn: val,
                                  sex: watched?.sex?.toLocaleLowerCase() ?? 'i',
                                  birthDate: watched.birthDate ?? '',
                              })
                          }

                          return false
                      }
                    : undefined,
            }}
            render={({ field, fieldState: { error } }) => (
                <PatientFormField
                    variant="input"
                    label="Numéro de sécurité sociale"
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    required={patientIsSameAsInsuredWatched}
                    dataCyScope="PatientField"
                    size="0.5"
                    inputProps={{
                        maxLength: socialSecurityNumberMinLength,
                    }}
                    {...field}
                    value={field.value ?? undefined}
                    disabled={isDisabled}
                    placeholder="Numéro de sécurité sociale"
                />
            )}
        />
    )
}

export default PatientSocialSecurityNumber
